export interface GameBonusFund {
    id: number;
    tournament_id: string;
    tournament_amount: string;
    bonus_amount: string;
    inviter_amount: string;
    company_amount: string;
    payout_amount?: Record<string, { place: number; amount: string; operation_id: string; created_at: string }>;
    created_at: string;
    updated_at: string;
}

export interface GameBonusGlobalStats {
    tournament_fund: string;
    bonus_fund: {
        total_collected: string;
        current_balance: string;
        total_paid: string;
    };
    human_wallet_tournament?: {
        total_collected: string;
        current_balance: string;
        total_paid: string;
    };
    bot_ai_wallet_tournament?: {
        total_collected: string;
        current_balance: string;
        total_paid: string;
    };
    ratings_prize_split?: { 1: number; 2: number; 3: number };
    inviter_fund: string;
    company_fund: string;
}

export interface GameBonusGlobalStatsResponse {
    success: boolean;
    data: GameBonusGlobalStats;
}

export interface GameBonusHistory {
    id: number;
    game_bonus_fund_id: number;
    token_operation_id: number;
    entry_amount: string;
    tournament_amount: string;
    bonus_amount: string;
    inviter_amount: string;
    company_amount: string;
    created_at: string;
    updated_at: string;
    token_operation?: any;
}

export interface GameBonusPayout {
    id: number;
    game_bonus_fund_id: number;
    fund_type: "tournament" | "bonus" | "inviter" | "company";
    amount: string;
    destination?: string;
    comment?: string;
    created_at: string;
    updated_at: string;
}

export interface GameBonusParams {
    page?: number;
    per_page?: number;
    tournament_id?: string;
    game_bonus_fund_id?: number | string;
    fund_type?: string;
    date_from?: string;
    date_to?: string;
    action?: string;
}

export interface PaginatedResponse<T> {
    success: boolean;
    data: T[];
    meta: {
        current_page: number;
        last_page: number;
        per_page: number;
        total: number;
    };
}

export const gameBonusTags = ["GameBonus"] as const;

export const gameBonusEndpoints = {
    getGameBonusSummary: {
        query: (params: GameBonusParams) => ({
            url: "/admin/game-bonus/summary",
            params,
        }),
        providesTags: ["GameBonus"],
    },
    getGameBonusHistory: {
        query: (params: GameBonusParams) => ({
            url: "/admin/game-bonus/history",
            params,
        }),
        providesTags: ["GameBonus"],
    },
    getGameBonusPayouts: {
        query: (params: GameBonusParams) => ({
            url: "/admin/game-bonus/payouts",
            params,
        }),
        providesTags: ["GameBonus"],
    },
    createGameBonusPayout: {
        query: (body: { game_bonus_fund_id: number; fund_type: string; amount: number; destination?: string; comment?: string }) => ({
            url: "/admin/game-bonus/payouts",
            method: "POST",
            body,
        }),
        invalidatesTags: ["GameBonus"],
    },
    getGameBonusGlobalStats: {
        query: () => ({
            url: "/admin/game-bonus/global-stats",
        }),
        providesTags: ["GameBonus"],
    },
    getRatingsPrizeSplit: {
        query: () => ({
            url: "/admin/game-bonus/prize-split",
        }),
        providesTags: ["GameBonus"],
    },
    updateRatingsPrizeSplit: {
        query: (body: { 1: number; 2: number; 3: number }) => ({
            url: "/admin/game-bonus/prize-split",
            method: "PUT",
            body,
        }),
        invalidatesTags: ["GameBonus"],
    },
};
